module.exports = __webpack_public_path__ + "img/Makeping-Logo-Black.713395be.png";